import gql from "graphql-tag";

const updateStatusAffiliates = gql`
  mutation updateStatusAffiliates($userIDs: [String!]!, $statusID: Int!) {
    updateStatusAffiliates(userIDs: $userIDs, statusID: $statusID) {
      message
      motive
      statusCode
    }
  }
`;

const updateDataAffiliateDrawer = gql`
  mutation updateAffiliateData(
    $affiliateID: String
    $data: [InputUpdateDataAffiliate]
  ) {
    updateAffiliateData(affiliateID: $affiliateID, data: $data) {
      message
      motive
      statusCode
    }
  }
`;

const deleteAffiliates = gql`
  mutation deleteAffiliates($userIDs: [ID!]!) {
    deleteAffiliates(userIDs: $userIDs) {
      message
      motive
      statusCode
    }
  }
`;

const createUserAndAffiliateByAgency = gql`
  mutation createUserAndAffiliateByAgency(
    $agencyID: Int!
    $userInfo: PublicUserInput!
    $driverInfo: DriverInfoInput!
    $currentVehicleInfo: CurrentVehicleInfoInput!
    $driverMP: Boolean
  ) {
    createUserAndAffiliateByAgency(
      agencyID: $agencyID
      userInfo: $userInfo
      driverInfo: $driverInfo
      currentVehicleInfo: $currentVehicleInfo
      driverMP: $driverMP
    ) {
      message
      motive
      statusCode
      extra {
        userID
        namesUser
        emailUser
        password
      }
    }
  }
`;

const createUserByAgency = gql`
  mutation createUserByAgency(
    $agencyID: Int!
    $userInfo: BasicUserByAgencyInput!
  ) {
    createUserByAgency(agencyID: $agencyID, userInfo: $userInfo) {
      message
      motive
      statusCode
      extra {
        userID
        namesUser
        emailUser
        password
      }
    }
  }
`;

const bulkCreateUsersByAgency = gql`
  mutation bulkCreateUsersByAgency(
    $agencyID: Int!
    $users: [BasicUserByAgencyInput!]!
  ) {
    bulkCreateUsersByAgency(agencyID: $agencyID, users: $users) {
      message
      motive
      statusCode
    }
  }
`;

const resetPasswordAndSendEmailAccount = gql`
  mutation resetPasswordAndSendEmailAccount(
    $userID: String!
    $password: String
  ) {
    resetPasswordAndSendEmailAccount(
      userID: $userID
      password: $password
      mailNewUser: false
    ) {
      message
      motive
      statusCode
    }
  }
`;

const registerScanCode = gql`
  mutation registerAffiliateQRScan(
    $affiliateID: String!
    $deviceInfo: DeviceInfoInput!
  ) {
    registerAffiliateQRScan(
      affiliateID: $affiliateID
      deviceInfo: $deviceInfo
    ) {
      message
      statusCode
      extra {
        urlLink
      }
    }
  }
`;

export {
  updateStatusAffiliates,
  updateDataAffiliateDrawer,
  deleteAffiliates,
  createUserAndAffiliateByAgency,
  createUserByAgency,
  bulkCreateUsersByAgency,
  resetPasswordAndSendEmailAccount,
  registerScanCode,
};
